import React, {Component, PropTypes} from 'react';
import classNames from 'classnames';
import './styles/Pagination.scss';
import PaginationButton from './PaginationButton';
import Translator from 'bazinga-translator';

const Pagination = (props)=>{

    const handleClick = (i) =>{
        return i !== props.activePage ? props.onChange(i) : null;
    };

    let listElements = [],
        i = 1,
        pages = props.pages;

    for(i;i<=pages;i++) {
        const visibleList = function() {
            if (props.activePage <= 3 && i <= 5) {
                return "is-visible"
            } else if (props.activePage >= props.pages - 3 && i >= props.pages - 5) {
                return "is-visible"
            } else if ((props.activePage + 2) >= i && i >= (props.activePage - 2)) {
                return "is-visible"
            } else {
                return ''
            }
        };
        const paginationList = function() {
            if (i == props.activePage) {
                return "active "
            } else {
                return ''
            }
        };
        const classes = classNames(paginationList() + visibleList());
        let value = i;

        listElements.push(
        <li key={value} className={classes} onClick={()=>handleClick(value)}><span>{i}</span></li>
        )
    }


    return(
        <div className="pagination">
            <PaginationButton disabled={props.disabledPrev}
                              type="prev"
                              onClick={props.onChange}
                              pages={props.pages}
                              activePage={props.activePage}
            >
                {Translator.trans('previous', [], 'app')}
            </PaginationButton>
            <ul className="pagination__list">
                {listElements}
                <li>
                    {Translator.trans('from', [], 'app')}
                    <span>{Math.floor(props.pages)}</span>
                </li>
            </ul>
            <PaginationButton disabled={props.disabledNext}
                              type="next"
                              onClick={props.onChange}
                              pages={props.pages}
                              activePage={props.activePage}
            >
                {Translator.trans('next', [], 'app')}
            </PaginationButton>
        </div>
    )
};

Pagination.propTypes = {
    pages: PropTypes.number.isRequired,
    activePage: PropTypes.number.isRequired
};

export default Pagination;


// WEBPACK FOOTER //
// ./src/_app/estimations/modals/components/Pagination/Pagination.js